/**
 * One label and colour per equivalency verdict, so the runs page and the plan
 * tab render the same conclusion the same way.
 */

export type VerdictColor = "default" | "success" | "warning" | "error";

export const VERDICT_LABELS: Record<string, string> = {
  identical: "Identical",
  equivalent: "Equivalent",
  equivalent_with_conditions: "Equivalent with conditions",
  not_equivalent: "Not equivalent",
  open_pending_items: "No conclusion yet",
  not_evaluated: "Not evaluated",
};

export const VERDICT_COLORS: Record<string, VerdictColor> = {
  identical: "success",
  equivalent: "success",
  equivalent_with_conditions: "warning",
  not_equivalent: "error",
  open_pending_items: "default",
  not_evaluated: "default",
};
